// Contract.jsx
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./styles/Contract.css";

const STAFF_API = "https://okna.co.tz/mrms/Staff.php";
const ITEMS_PER_PAGE = 8;
const ROLES = ["Admin", "Cashier", "Waitress", "Cleaner", "Chef"];

export default function Contract() {
  const token = localStorage.getItem("token");

  const [staffList, setStaffList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingStaffId, setEditingStaffId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    role: "",
    phone_number: "",
    email: "",
    password: "",
    pin: ""
  });

  useEffect(() => {
    if (!token) {
      Swal.fire("Session Expired", "Login again", "warning");
      return;
    }
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      const res = await fetch(STAFF_API);
      const data = await res.json();
      setStaffList(data.filter(s => s.contract === "yes"));
    } catch {
      Swal.fire("Error", "Failed to load staff", "error");
    }
  };

  const handleChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData({ full_name: "", role: "", phone_number: "", email: "", password: "", pin: "" });
    setEditingStaffId(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!formData.full_name || !formData.role || !formData.phone_number) {
      return Swal.fire("Missing fields", "Fill required fields", "warning");
    }

    if (formData.role === "Waitress" && !formData.pin) {
      return Swal.fire("PIN required", "Waitress must have PIN", "warning");
    }

    const payload = {
      ...formData,
      contract: "yes",
      email: formData.role === "Waitress" ? null : formData.email,
      password: formData.role === "Waitress" ? null : formData.password,
      pin: formData.role === "Waitress" ? formData.pin : null
    };

    try {
      const res = await fetch(
        editingStaffId ? `${STAFF_API}?id=${editingStaffId}` : STAFF_API,
        {
          method: editingStaffId ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();
      Swal.fire("Success", data.message || "Saved", "success");
      setShowModal(false);
      resetForm();
      loadStaff();
    } catch {
      Swal.fire("Error", "Submit failed", "error");
    }
  };

  const toggleActive = async staff => {
    await fetch(`${STAFF_API}?id=${staff.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...staff,
        active: staff.active === "yes" ? "no" : "yes"
      })
    });
    loadStaff();
  };

  const pageData = staffList.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div className="container">
      <header className="header">
        <h2>👨‍💼 Contract Staff</h2>
        <button className="btn-add" onClick={() => { resetForm(); setShowModal(true); }}>
          + Add Staff
        </button>
      </header>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pageData.map(staff => (
              <tr key={staff.id}>
                <td>{staff.full_name}</td>
                <td>{staff.role}</td>
                <td>
                  <span className={`badge ${staff.active}`} onClick={() => toggleActive(staff)}>
                    {staff.active}
                  </span>
                </td>
                <td>
                  <button onClick={() => { setEditingStaffId(staff.id); setFormData(staff); setShowModal(true); }}>✏️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-box">
            <h3>{editingStaffId ? "Edit" : "Add"} Staff</h3>
            <form onSubmit={handleSubmit}>
              <input name="full_name" placeholder="Full Name" value={formData.full_name} onChange={handleChange} />
              <select name="role" value={formData.role} onChange={handleChange}>
                <option value="">Role</option>
                {ROLES.map(r => <option key={r}>{r}</option>)}
              </select>
              <input name="phone_number" placeholder="Phone" value={formData.phone_number} onChange={handleChange} />

              {formData.role === "Waitress" ? (
                <input name="pin" placeholder="PIN" value={formData.pin} onChange={handleChange} />
              ) : (
                <>
                  <input name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
                  <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} />
                </>
              )}

              <div className="actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


